import { render } from "./TeacherPageHeading.vue?vue&type=template&id=5a45bd4e&ts=true"
import script from "./TeacherPageHeading.vue?vue&type=script&lang=ts"
export * from "./TeacherPageHeading.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__